import React, { useImperativeHandle, useRef,useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import CoinConversion from "./coinConversion";
import { IRefModalCoinConversion } from "./interface";
import coinConversionSchema from "./shemas";

const ModalCoinConversion: React.ForwardRefRenderFunction<IRefModalCoinConversion> = (_, ref) => {
	const { translate, currentLanguage } = useTranslation(); 
	const { addToast} = RCCHookToast();

	const [coin1Id, setCoin1Id] = useState<number>();
	const [valuesMonthlyData, setValuesMonthlyData] = useState<{ year: string; data: string[][] }[]>([]);

	const modal = useRef<RCCRefModalProps>(null);
	
	const { 
		control,
		setValue,
		setError,
		clearErrors,
		formState: { errors },
		reset,
		handleSubmit
	}= useForm();


	const actionOpen = async(coinId?: number) => {
		setValuesMonthlyData([]);
		setCoin1Id(coinId);
		reset();
		modal.current?.openModal();
	};

	const onSubmit = async(data:any) => {
		try {
			clearErrors();
			modal.current?.setLoadingButton();

			await coinConversionSchema(translate).validate(data, {
				abortEarly: false
			});

			if(Number(data.coin1) === Number(data.coin2)){
				addToast({
					color: "yellow",
					description: translate("Moeda de Origem e Moeda de Destino devem ser diferentes"),
					title: translate("Atenção")
				});
				modal.current?.resetLoadingButton();
				return;
			}

			await RCCServicesApi.postRequest({
				method: "Coins/UpdateConversion",
				body: {
					coin1: data.coin1,
					coin2: data.coin2,
					currentLanguage,
					motba002001: valuesMonthlyData
				}
			});

			modal.current?.resetLoadingButton();
			modal.current?.closeModal();

			addToast({
				color: "green",
				description: translate("Conversões de moeda alteradas com sucesso"),
				title: translate("Sucesso")
			});

		} catch (err: any) {
			modal.current?.resetLoadingButton();
			if(getValidationErrors(err, setError)){
				addToast({
					color: "yellow",
					description: translate("Verifique os campos e tente novamente"),
					title: translate("Atenção")
				});
			}

			standardErrorMessages(err, translate("Erro ao alterar conversões de moeda"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		actionOpen
	}));

	return (
		<Modal
			ref={modal}
			header={{
				icon: {
					name: "coin"
				},
				title: translate("Converter Moedas")
			}}
			onSubmit={handleSubmit(onSubmit)}
			styleInline={ModalSide}
		>
			<CoinConversion
				errors={errors}
				control={control}
				setValue={setValue}
				coinId={coin1Id}
				updateValues={setValuesMonthlyData}
			/>
		</Modal>
	);
};

export default React.forwardRef(ModalCoinConversion);
